// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"0ddaa347","390":"d7ae5a66","416":"5d900f69","916":"d7ae5a66"}[chunkId] + ".chunk.css";
};